import { render, staticRenderFns } from "./edit-profile.vue?vue&type=template&id=5e785835"
import script from "./edit-profile.vue?vue&type=script&lang=js"
export * from "./edit-profile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports